/**
 * author       : zwl
 * createTime   : 2018/6/28 下午5:08
 * description  :
 */
import api from 'util/axios'

export function createCargo (params) {
  return api({
    method: 'post',
    url: '/publishCargo/' + params.appId,
    data: params
  })
}

export function updateCargo (cargoId, params) {
  return api({
    method: 'put',
    url: '/publishCargo/' + cargoId + '/' + params.appId,
    data: params
  })
}

export function deleteCargo (params) {
  return api({
    method: 'delete',
    url: '/publishCargo/' + params.appId,
    data: params
  })
}
